import {isNil} from 'ramda';

import {AuctionVehicleResponseBody} from '../types';

const stripCurrencyPrefix = (value: string | null | undefined): string | null | undefined => {
  if (isNil(value)) {
    return value;
  }

  return value.replace(/^CURRENCY_/, '');
};

export function normalizeAuctionVehicleCurrencies(
  auctionVehicle: AuctionVehicleResponseBody
): AuctionVehicleResponseBody {
  return {
    ...auctionVehicle,
    currency: stripCurrencyPrefix(auctionVehicle.currency),
    originalCurrency: stripCurrencyPrefix(auctionVehicle.originalCurrency),
  };
}
